import { CheckSquare, Shield, ClipboardList, Bell, GitBranch } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { StepType } from './types.ts'

export interface StepTypeMeta {
  label: string
  icon: LucideIcon
  bgColor: string
  textColor: string
  borderColor: string
}

export const STEP_TYPE_META: Record<StepType, StepTypeMeta> = {
  task: {
    label: 'Aufgabe',
    icon: CheckSquare,
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-700',
    borderColor: 'border-blue-200',
  },
  approval: {
    label: 'Freigabe-Gate',
    icon: Shield,
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-700',
    borderColor: 'border-amber-300',
  },
  form: {
    label: 'Formular',
    icon: ClipboardList,
    bgColor: 'bg-purple-50',
    textColor: 'text-purple-700',
    borderColor: 'border-purple-200',
  },
  notification: {
    label: 'Benachrichtigung',
    icon: Bell,
    bgColor: 'bg-teal-50',
    textColor: 'text-teal-700',
    borderColor: 'border-teal-200',
  },
  condition: {
    label: 'Bedingung',
    icon: GitBranch,
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-200',
  },
}
